// src/components/PathProductArtOfPossible.jsx
import React, { useState, useRef, useEffect } from 'react';
import { Link, Element, Events } from 'react-scroll';
import PathPersonas from './PathPersonas';
import CompPrintCover from './CompPrintCover';

// Mock data and helper - adjust or replace with real data/logic later
const mockComments = {
    "introduction": [
        {
            id: 1,
            user: { name: "Jane Doe", avatar: "/media/persona/f-1.png" },
            timestamp: "2024-03-20T10:30:00Z",
            content: "The challenge section really resonates with our current situation."
        },
        {
            id: 2,
            user: { name: "John Smith", avatar: "/media/persona/m-2.png" },
            timestamp: "2024-03-20T11:15:00Z",
            content: "Agreed. We should emphasize the cost implications more."
        }
    ],
    "chapter-1": [
        {
            id: 3,
            user: { name: "Emily Chen", avatar: "/media/persona/f-3.png" },
            timestamp: "2024-03-20T14:20:00Z",
            content: "The technology comparison could be more detailed here."
        }
    ],
};

const getTimeAgo = (timestamp) => {
    const seconds = Math.floor((new Date() - new Date(timestamp)) / 1000);
    let interval = seconds / 31536000; if (interval > 1) return Math.floor(interval) + 'y ago';
    interval = seconds / 2592000; if (interval > 1) return Math.floor(interval) + ' mo ago';
    interval = seconds / 86400; if (interval > 1) return Math.floor(interval) + 'd ago';
    interval = seconds / 3600; if (interval > 1) return Math.floor(interval) + 'h ago';
    interval = seconds / 60; if (interval > 1) return Math.floor(interval) + 'm ago';
    return Math.floor(seconds) + 's ago';
};


const PathProductArtOfPossible = ({
    columns,
    handleTitleEdit,
    handleSubtitleEdit,
    handleLocationEdit,
    handlePersonFieldEdit,
    handleContentEdit,
    deleteItem,
    // addNewItem, // Keep commented if add buttons are not used yet
    // addNewScene, // Keep commented if add scene button is not used yet
    handlePrint,
    storyDayToDayRef,
    formData,
    personaData,
    storySpeakerSummaryResult
}) => {

    //console.log('columns', columns);

    const [activeSection, setActiveSection] = useState(Object.keys(columns)[0] || 'introduction');
    const [showCommentsSidebar, setShowCommentsSidebar] = useState(false);
    const [showAllComments, setShowAllComments] = useState(false);
    const [newComment, setNewComment] = useState('');
    let renderedOutcomes = false; // Reset flag on each render

    // Scroll event listener to update active section
    useEffect(() => {
        Events.scrollEvent.register('begin', () => { });
        Events.scrollEvent.register('end', () => { });

        const handleScroll = () => {
            const scrollContainer = document.getElementById('storyScrollContainer');
            if (!scrollContainer) return;

            const scrollPosition = scrollContainer.scrollTop;
            const sections = Object.keys(columns);
            let currentSection = sections[0];

            sections.forEach(section => {
                const element = document.getElementById(section);
                if (element) {
                    // Use getBoundingClientRect relative to the scroll container if possible,
                    // or adjust logic based on element.offsetTop relative to container scroll.
                    // Using offsetTop relative to the scroll container parent:
                    const containerTop = scrollContainer.getBoundingClientRect().top;
                    const elementTopRelativeToContainer = element.getBoundingClientRect().top - containerTop + scrollPosition;

                    // Check if the top of the element is at or above the middle of the *container's* visible height
                    if (elementTopRelativeToContainer <= scrollPosition + scrollContainer.clientHeight / 2) {
                         currentSection = section;
                    }
                }
            });
             if (activeSection !== currentSection) {
                setActiveSection(currentSection);
            }
        };

        const scrollContainer = document.getElementById('storyScrollContainer');
        if (scrollContainer) {
            scrollContainer.addEventListener('scroll', handleScroll, { passive: true });
            handleScroll(); // Initial check
        }

        return () => {
            const scrollContainer = document.getElementById('storyScrollContainer');
            if (scrollContainer) {
                scrollContainer.removeEventListener('scroll', handleScroll);
            }
            Events.scrollEvent.remove('begin');
            Events.scrollEvent.remove('end');
        };
        // Add columns dependency if its keys might change, otherwise it might not be needed
    }, [columns, activeSection]); // Rerun if columns change or activeSection updates externally (though unlikely here)


    const handleAddComment = () => {
        if (!newComment.trim()) return;
        // Implement actual comment saving logic here
        console.log('Adding comment (not implemented):', {
            section: activeSection,
            content: newComment,
            timestamp: new Date().toISOString(),
            user: { name: 'Current User', avatar: '/media/persona/m-1.png' } // Replace with actual user
        });
        setNewComment('');
    };

    // Moved renderItem function here
     const renderItem = (item, columnId) => {
        switch (item.type) {
            case 'technology':
                const device = typeof item.content === 'string'
                    ? item.content // Assuming string content might just be the name
                    : item.content; // Assuming object content

                return (
                    <div key={item.id} className="text-zinc-300 bg-amber-400/5x p-2 rounded relative group">
                         <button
                            onClick={() => deleteItem(columnId, item.id)}
                            className="absolute -right-2 -top-2 text-zinc-700 opacity-0 group-hover:opacity-100 hover:text-zinc-400 transition-opacity print:hidden"
                            title="Delete (Undo with Cmd/Ctrl+Z)"
                        >
                            <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" viewBox="0 0 20 20" fill="currentColor">
                                <path fillRule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clipRule="evenodd" />
                            </svg>
                        </button>
                        {typeof device === 'object' && device?.name && (
                            <div className="mb-2 group relative">

                                <span
                                    className="text-amber-400 -mt-2 px-2 py-1 rounded cursor-text inline-block font-semibold text-lg"
                                    //contentEditable
                                    suppressContentEditableWarning
                                    onBlur={(e) => {
                                        const updatedDevice = { ...device, name: e.target.textContent };
                                        handleContentEdit(columnId, item.id, updatedDevice);
                                    }}
                                    onKeyDown={(e) => { if (e.key === 'Enter') { e.preventDefault(); e.target.blur(); } }}
                                >
                                    {device.name}
                                </span>
                            </div>
                        )}
                        {typeof device === 'object' && device?.capabilities && (
                            <div className="mb-2">
                                <div className="text-amber-400 ml-2">Capabilities</div>{' '}
                                <span
                                    className="hover:bg-zinc-50x/5 focus:bg-zinc-50x/5 px-2 py-1 rounded cursor-text inline-block"
                                    //contentEditable
                                    suppressContentEditableWarning
                                     onBlur={(e) => {
                                        const updatedDevice = { ...device, capabilities: e.target.textContent };
                                        handleContentEdit(columnId, item.id, updatedDevice);
                                    }}
                                    onKeyDown={(e) => { if (e.key === 'Enter') { e.preventDefault(); e.target.blur(); } }}
                                >
                                    {device.capabilities}
                                </span>
                            </div>
                        )}
                         {typeof device === 'object' && device?.actions && (
                             <div className="mb-2">
                                 <div className="text-amber-400 ml-2">Actions</div>{' '}
                                 <span
                                     className="hover:bg-zinc-50x/5 focus:bg-zinc-50x/5 px-2 py-1 rounded cursor-text inline-block"
                                     contentEditable
                                     suppressContentEditableWarning
                                      onBlur={(e) => {
                                        const updatedDevice = { ...device, actions: e.target.textContent };
                                        handleContentEdit(columnId, item.id, updatedDevice);
                                    }}
                                    onKeyDown={(e) => { if (e.key === 'Enter') { e.preventDefault(); e.target.blur(); } }}
                                 >
                                     {device.actions}
                                 </span>
                             </div>
                         )}
                         {typeof device === 'string' && (
                             <span className="font-semibold text-lg">{device}</span> // Render string directly if it's just a name
                         )}
                    </div>
                );


            case 'participant':
            case 'person':
                 if (!item.content) {
                    console.warn(`Item with id ${item.id} in column ${columnId} has missing content for type 'person'/'participant'.`);
                    return <div key={item.id} className="text-red-500 p-2">Error: Missing person data</div>;
                }
                return (
                    <div key={item.id} className="w-full group relative">
                        <div className="rounded-lg bg-zinc-600/5 p-2 flex flex-col h-full gap-2">
                             <button
                                onClick={() => deleteItem(columnId, item.id)}
                                className="absolute top-1 right-1 text-zinc-700 opacity-0 group-hover:opacity-100 hover:text-zinc-400 transition-opacity p-1"
                                title="Delete (Undo with Cmd/Ctrl+Z)"
                            >
                                <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" viewBox="0 0 20 20" fill="currentColor">
                                    <path fillRule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clipRule="evenodd" />
                                </svg>
                            </button>

                            <div className="flex gap-4">
                                {item.content.image && (
                                    <div
                                        className="w-16 h-16 ml-2 mt-3 rounded-full bg-white flex-shrink-0"
                                        style={{
                                            backgroundImage: `url(${item.content.image.startsWith('/') ? item.content.image : '/media/persona/' + item.content.image})`,
                                            backgroundSize: 'cover',
                                            backgroundPosition: 'top'
                                        }}
                                    />
                                )}
                                <div className="flex flex-col flex-grow">
                                    <div
                                        className='text-sky-500 text-lg font-semibold w-full hover:bg-zinc-50x/5 focus:bg-zinc-50x/5 px-2 py-1 rounded cursor-text mt-2'
                                        //contentEditable
                                        suppressContentEditableWarning
                                        onBlur={(e) => handlePersonFieldEdit(columnId, item.id, 'name', e.target.textContent)}
                                        onKeyDown={(e) => { if (e.key === 'Enter') { e.preventDefault(); e.target.blur(); } }}
                                    >
                                        {item.content.name || 'Unnamed'}
                                    </div>
                                    <div
                                        className='text-zinc-300 text-sm w-full hover:bg-zinc-50x/5 focus:bg-zinc-50x/5 px-2 py-1 rounded cursor-text'
                                        //contentEditable
                                        suppressContentEditableWarning
                                        onBlur={(e) => handlePersonFieldEdit(columnId, item.id, 'role', e.target.textContent)}
                                        onKeyDown={(e) => { if (e.key === 'Enter') { e.preventDefault(); e.target.blur(); } }}
                                    >
                                        {item.content.role || 'No role'}
                                    </div>
                                </div>
                            </div>

                            <div
                                className='text-zinc-50 text-md w-full hover:bg-zinc-50x/5 focus:bg-zinc-50x/5 px-2 py-1 rounded cursor-text mt-2 pb-2'
                                //contentEditable
                                suppressContentEditableWarning
                                onBlur={(e) => handlePersonFieldEdit(columnId, item.id, 'actions', e.target.textContent)}
                                onKeyDown={(e) => { if (e.key === 'Enter') { e.preventDefault(); e.target.blur(); } }}
                            >
                                {item.content.actions || 'No actions specified'}
                            </div>
                        </div>
                    </div>
                );

            case 'text':
                if (item.label === 'Customer Value' || item.label === 'Business Value') {
                    return (
                        <div key={item.id} className="w-full h-full group relative -mt-2">
                             <button
                                onClick={() => deleteItem(columnId, item.id)}
                                className="absolute top-1 right-1 text-zinc-700 opacity-0 group-hover:opacity-100 hover:text-zinc-400 transition-opacity z-10 p-1"
                                title="Delete (Undo with Cmd/Ctrl+Z)"
                            >
                                <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" viewBox="0 0 20 20" fill="currentColor">
                                    <path fillRule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clipRule="evenodd" />
                                </svg>
                            </button>
                            <div className="flex gap-4 h-full">
                                <div className="bg-green-500/5x h-full rounded p-4 flex-grow">
                                    <h4 className="text-green-400 font-semibold text-lg mb-2">{item.label}</h4>
                                    <div
                                        className="text-zinc-300 w-full hover:bg-green-200/25x focus:bg-zinc-50x/5 py-1 rounded cursor-text min-h-[2em]" // Added min-height
                                        //contentEditable
                                        suppressContentEditableWarning
                                        onBlur={(e) => handleContentEdit(columnId, item.id, e.target.textContent)}
                                        onKeyDown={(e) => { if (e.key === 'Enter') { e.preventDefault(); e.target.blur(); } }}
                                    >
                                        {item.content}
                                    </div>
                                </div>
                            </div>
                        </div>
                    );
                }
                 // Default text rendering (like Description in Intro/Conclusion)
                 // Added delete button and editability
                return (
                     <div key={item.id} className="mb-2 rounded-lg p-4 px-10 relative group">
                         <button
                            onClick={() => deleteItem(columnId, item.id)}
                             className="absolute top-1 right-1 text-zinc-700 opacity-0 group-hover:opacity-100 hover:text-zinc-400 transition-opacity p-1"
                            title="Delete (Undo with Cmd/Ctrl+Z)"
                        >
                             <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" viewBox="0 0 20 20" fill="currentColor">
                                 <path fillRule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clipRule="evenodd" />
                             </svg>
                        </button>
                        <h4 className="text-zinc-50 text-lg mb-2">{item.label}</h4>
                        <div
                            className="text-zinc-100 leading-8 hover:bg-zinc-50x/5 focus:bg-zinc-50x/5 px-2 py-1 -ml-2 rounded cursor-text"
                            //contentEditable
                            suppressContentEditableWarning
                            onBlur={(e) => handleContentEdit(columnId, item.id, e.target.textContent)}
                            onKeyDown={(e) => {
                                // Allow shift+enter for new lines
                                if (e.key === 'Enter' && !e.shiftKey) {
                                    e.preventDefault();
                                    e.target.blur();
                                }
                            }}
                        >
                            {typeof item.content === 'string' ? item.content : JSON.stringify(item.content)}
                         </div>
                    </div>
                );

            case 'outcome':
                 // Attempt to parse if string, otherwise use as is. Handle potential errors.
                 let outcomeData = {};
                 try {
                    outcomeData = typeof item.content === 'string' ? JSON.parse(item.content) : item.content || {};
                 } catch (error) {
                    console.error("Failed to parse outcome content:", item.content, error);
                    outcomeData = { benefit: "Error loading benefit", impact: "Error loading impact" };
                 }

                 return (
                     <div key={item.id} className="rounded-lg bg-green-900/10 p-4 relative group">
                         <button
                             onClick={() => deleteItem(columnId, item.id)}
                             className="absolute top-1 right-1 text-zinc-700 opacity-0 group-hover:opacity-100 hover:text-zinc-400 transition-opacity p-1"
                             title="Delete (Undo with Cmd/Ctrl+Z)"
                         >
                            <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" viewBox="0 0 20 20" fill="currentColor">
                                <path fillRule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clipRule="evenodd" />
                            </svg>
                         </button>
                         <div className="space-y-4">
                             <div>
                                 <div
                                     className="text-zinc-50 text-lg hover:bg-zinc-50x/5 focus:bg-zinc-50x/5 px-2 py-1 rounded cursor-text"
                                     //contentEditable
                                     suppressContentEditableWarning
                                     onBlur={(e) => handleContentEdit(columnId, item.id, JSON.stringify({ ...outcomeData, benefit: e.target.textContent }))}
                                     onKeyDown={(e) => { if (e.key === 'Enter') { e.preventDefault(); e.target.blur(); } }}
                                 >
                                     {outcomeData.benefit || 'Benefit not specified'}
                                 </div>
                             </div>
                             <div>
                                 <div className="text-green-300 mt-2 text-base mb-2 ml-2">Impact</div>
                                 <div
                                     className="text-zinc-400 print:text-zinc-100 print:text-sm hover:bg-zinc-50x/5 focus:bg-zinc-50x/5 px-2 py-1 rounded cursor-text"
                                     // contentEditable
                                     suppressContentEditableWarning
                                     onBlur={(e) => handleContentEdit(columnId, item.id, JSON.stringify({ ...outcomeData, impact: e.target.textContent }))}
                                     onKeyDown={(e) => { if (e.key === 'Enter' && !e.shiftKey) { e.preventDefault(); e.target.blur(); } }}
                                >
                                     {outcomeData.impact || 'Impact not specified'}
                                 </div>
                             </div>
                         </div>
                     </div>
                 );

             // Removed list and valueProps as they seemed unused based on initial state structure
             // If they are needed, they can be added back similarly

            default:
                return (
                    <div key={item.id} className="mb-2 rounded-lg bg-black/20 p-4">
                        <h4 className="text-sky-400 text-lg mb-2">{item.label || 'Unlabeled Item'}</h4>
                        <div className="text-zinc-400">
                            {typeof item.content === 'string' ? item.content : JSON.stringify(item.content)}
                        </div>
                    </div>
                );
        }
    };


    return (
        <div className='flex h-full'>
            {/* First child - Navigation sidebar */}
             <div className="w-2/12 h-full bg-zinc-900 p-4 flex flex-col pt-12 print:hidden">
                 <nav className="flex flex-col space-y-1 md:space-y-0 md:grid md:grid-cols-12 text-zinc-50 sticky top-4 ml-4">
                     {Object.entries(columns).map(([columnId, column], index) => {
                         const isActive = activeSection === columnId;
                         const isPassed = index < Object.keys(columns).indexOf(activeSection);

                         return (
                             <div key={columnId} className="flex md:contents">
                                 {/* Vertical Line and Dot */}
                                 <div className="col-start-1 col-end-2 -ml-2 h-16 md:h-24 relative">
                                     <div className="h-full w-8 flex items-center justify-center">
                                         {index !== Object.keys(columns).length - 1 && (
                                             <div className={`h-full w-0.5 ${isActive || isPassed ? 'bg-sky-500' : 'bg-zinc-700'} pointer-events-none transition-colors duration-300 ${index === 0 ? 'mt-4 md:mt-12' : ''}`} />
                                         )}
                                     </div>
                                     <div className={`w-8 h-8 absolute top-0 left-0 rounded-full border-2 shadow text-center flex items-center justify-center transition-all duration-300 ${isActive || isPassed ? 'text-zinc-50 border-sky-600 bg-sky-900' : 'bg-zinc-700 border-zinc-700 text-zinc-400'}`}>
                                         <span className="text-xs">{index + 1}</span>
                                     </div>
                                 </div>
                                 {/* Link */}
                                 <div className="col-start-3 col-end-12   pl-2">
                                      <Link
                                         to={columnId}
                                         spy={true}
                                         smooth={true}
                                         duration={500}
                                         offset={-80} // Adjust offset as needed
                                         containerId="storyScrollContainer"
                                         activeClass="active-scroll-link" // Optional: for specific active styling via CSS
                                         className={`cursor-pointer transition-colors duration-200 block text-sm md:text-base ${isActive ? "text-zinc-50 font-medium" : "text-zinc-500 hover:text-zinc-200"}`}
                                     >
                                         {column.title}
                                     </Link>
                                 </div>
                             </div>
                         );
                     })}
                 </nav>
             </div>


            {/* Second child - Main content */}
            <div
                id="storyScrollContainer"
                 className={`${showCommentsSidebar ? 'w-8/12' : 'w-10/12'} h-full bg-black/10 overflow-y-auto main-content-scroll transition-all duration-300 px-4 print:overflow-visible prxint:bg-white prixnt:text-black print:w-full print:px-12`}
                ref={storyDayToDayRef} // Pass ref for printing
            >
                {/* Cover Page for Print */}
                <CompPrintCover formData={formData} coverType={'day-to-day'} />

                <div className="p-4 print:p-0">
                     {/* Print Button - Moved inside scrolling container if needed */}
                     <div className=' absolute top-2 right-14 z-20 pr-4 p-2 transition-colors flex items-center gap-2 print:hidden'>
                        <button
                            onClick={handlePrint}
                             className="bg-zinc-800 hover:bg-zinc-600 text-white px-3 py-2 rounded-md transition-colors flex items-center gap-2"
                        >
                             <img src={'/util/app/b3-admin-export.svg'} className='h-5 w-5' alt="Export" />
                            <span>Export</span>
                        </button>

                     <button
                        onClick={handlePrint}
                         className="bg-zinc-800 hover:bg-zinc-600 text-white px-3 py-2 rounded-md transition-colors flex items-center gap-2"
                    >
                         <img src={'/util/app/b3-admin-export.svg'} className='h-5 w-5' alt="Export" />
                        <span>Viz</span>
                    </button>

                    </div>

                    

                     {/* Personas Section */}
                     <div className="mb-12 pt-12 prxint:mt-16">
                        <div className='ml-12'>
                        <h2 className="text-zinc-50 pxrint:text-black text-3xl mb-2 font-medium">Characters for Art of Possible</h2>
                        <p className="text-zinc-400 prxint:text-zinc-600 text-lg mb-6">Representative roles related to the story, use your understanding of the situation and real people to refine</p>
                        </div>
                        <div className='flex justify-center print:block'>
                            {/* Ensure PathPersonas is styled appropriately for print if needed */}
                            <PathPersonas personaData={personaData} formData={formData} />
                        </div>
                    </div>

                    {/* Story Chapters */}
                    {Object.entries(columns).map(([columnId, column], index) => (
                        <React.Fragment key={columnId}>
                            <Element
                                name={columnId}
                                id={columnId}
                                className={`relative ${index === 0 ? "pt-0 print:pt-8" : "pt-16 print:pt-24"} print:break-before-page`} // Add print:break-before-page for page breaks
                            >
                                <div className="rounded-lg p-2 overflow-hidden print:overflow-visible">

                                    {/* Chapter Header Flex Container */}
                                     <div className='flex items-start mb-4'> {/* Use items-start */}
                                         {/* Chapter Number */}
                                         <div className='flex-shrink-0 text-zinc-50 border-sky-600 bg-sky-900 border-2 text-xl w-10 h-10 rounded-full mr-4 -ml-2 text-center flex items-center justify-center prixnt:bg-sky-100 prixnt:text-sky-700 prxint:border-sky-300'>
                                            {index + 1}
                                        </div>

                                         {/* Title, Location, Talk Track Container */}
                                         <div className="flex-grow -mt-1"> {/* Adjust margin if needed */}
                                             <div className="flex justify-between items-start mb-1">
                                                {/* Title */}
                                                <h3
                                                    className="text-zinc-50 prixnt:text-black text-2xl font-medium hover:bg-zixnc-50/5 focus:bg-zinc-50x/5 px-2 py-1 rounded cursor-text"
                                                    //contentEditable={!columnId.match(/^(introduction|conclusion)$/)} // Only chapters editable
                                                    suppressContentEditableWarning
                                                    onBlur={(e) => !columnId.match(/^(introduction|conclusion)$/) && handleTitleEdit(columnId, e.target.textContent)}
                                                    onKeyDown={(e) => { if (e.key === 'Enter') { e.preventDefault(); e.target.blur(); } }}
                                                >
                                                    {column.title}
                                                </h3>
                                                {/* Location */}
                                                {column.location && (
                                                    <div
                                                        className="flex items-center flex-shrink-0 ml-4"
                                                        //contentEditable={!columnId.match(/^(introduction|conclusion)$/)}
                                                        suppressContentEditableWarning
                                                        onBlur={(e) => !columnId.match(/^(introduction|conclusion)$/) && handleLocationEdit(columnId, e.target.textContent)}
                                                         onKeyDown={(e) => { if (e.key === 'Enter') { e.preventDefault(); e.target.blur(); } }}
                                                    >
                                                         <div className="bg-sky-500/10 font-semibold hover:bg-zxinc-50/5 focus:bg-zinc-50x/5 px-3 py-1 rounded-full text-sm text-sky-600 prxint:bg-sky-50 prxint:text-sky-700 cursor-text">
                                                            {column.location}
                                                        </div>
                                                    </div>
                                                )}
                                            </div>

                                             {/* Talk Track / Opening/Middle/Closing */}
                                             {index !== 0 && index !== Object.keys(columns).length - 1 && column.talkTrack && (
                                                 <p
                                                     className="text-zinc-100 prxint:text-zinc-700 text-md leading-relaxed mb-4 w-full hover:bg-zinc-50x/5 focus:bg-zinc-50x/5 px-2 py-1 rounded cursor-text"
                                                     //contentEditable // Assuming talkTrack is editable
                                                     suppressContentEditableWarning
                                                     onBlur={(e) => handleSubtitleEdit(columnId, e.target.textContent)} // Assuming subtitle handler works for talkTrack too
                                                     onKeyDown={(e) => { if (e.key === 'Enter' && !e.shiftKey) { e.preventDefault(); e.target.blur(); } }} // Allow Shift+Enter
                                                >
                                                    {column.talkTrack}
                                                </p>
                                            )}
                                             {index === 0 && storySpeakerSummaryResult?.opening && (
                                                <p className="text-zinc-100 prixnt:text-zinc-700 text-md leading-relaxed mb-4 w-full px-2 py-1 rounded ">
                                                    {storySpeakerSummaryResult.opening}
                                                </p>
                                             )}
                                             {index === 0 && storySpeakerSummaryResult?.middle && (
                                                 <p className="text-zinc-100 prixnt:text-zinc-700 text-md leading-relaxed mb-4 w-full px-2 py-1 rounded ">
                                                     {storySpeakerSummaryResult.middle}
                                                 </p>
                                             )}
                                             {index === Object.keys(columns).length - 1 && storySpeakerSummaryResult?.closing && (
                                                 <p className="text-zinc-100 prxint:text-zinc-700 text-md leading-relaxed mb-4 w-full px-2 py-1 rounded ">
                                                     {storySpeakerSummaryResult.closing}
                                                 </p>
                                             )}
                                         </div>
                                     </div>


                                    {/* Subtitle / Story */}
                                     {column.subtitle && (
                                         <div className="w-full flex pl-12 mb-6 print:pl-10">
                                            <div
                                                 className="text-zinc-200 prixnt:text-zinc-800 text-base/7 mb-4 w-full hover:bg-zinc-50x/5 focus:bg-zinc-50x/5 px-2 py-1 rounded cursor-text"
                                                 // contentEditable={!columnId.match(/^(introduction|conclusion)$/)} // Only chapters editable
                                                suppressContentEditableWarning
                                                onBlur={(e) => !columnId.match(/^(introduction|conclusion)$/) && handleSubtitleEdit(columnId, e.target.textContent)}
                                                 onKeyDown={(e) => { if (e.key === 'Enter' && !e.shiftKey) { e.preventDefault(); e.target.blur(); } }}
                                            >
                                                {column.subtitle}
                                            </div>
                                        </div>
                                    )}

                                    {/* Items Container */}
                                    <div className="space-y-6 -ml-2 pl-2"> {/* Added padding-left to align with content */}

                                         {/* Participants/Persons Section */}
                                         {columnId !== 'conclusion' && columnId !== 'introduction' && column.items?.some(item => item.type === 'participant' || item.type === 'person') && (
                                             <div className='w-full flex items-start pt-6'>
                                                 <img src="/util/app/b3-admin-path-people.svg" className="h-7 opacity-80 mr-4 mt-1 print:hidden" alt="People Icon"/>
                                                 <div className="flex-grow grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
                                                     {column.items
                                                         .filter(item => item.type === 'participant' || item.type === 'person')
                                                         .map(item => renderItem(item, columnId))}
                                                 </div>
                                                 {/* Add Person Button Placeholder - Uncomment if needed */}
                                                 {/* <div className='flex justify-center ml-6 print:hidden self-center'>
                                                     <button
                                                         type="button"
                                                         onClick={() => addNewItem(columnId, 'person', 'Key Person')}
                                                         className="flex items-center h-10 w-10 justify-center p-3 rounded-md border border-dashed border-sky-500/50 text-sky-500 hover:bg-sky-500/10 transition-colors"
                                                         title="Add Person"
                                                     >
                                                        <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4v16m8-8H4" /></svg>
                                                     </button>
                                                 </div> */}
                                             </div>
                                         )}

                                         {/* Values Section */}
                                         {columnId !== 'conclusion' && columnId !== 'introduction' && column.items?.some(item => item.type === 'text' && (item.label === 'Customer Value' || item.label === 'Business Value')) && (
                                             <div className='w-full flex items-start pt-6'>
                                                 <img src="/util/app/b3-admin-path-value2.svg" className="h-7 opacity-80 mr-4 mt-1 print:hidden" alt="Value Icon"/>
                                                 <div className="flex-grow grid grid-cols-1 md:grid-cols-2 gap-4">
                                                    {column.items
                                                         .filter(item => item.type === 'text' && (item.label === 'Customer Value' || item.label === 'Business Value'))
                                                         .map(item => renderItem(item, columnId))}
                                                </div>
                                                {/* Add Value Button Placeholder - Uncomment if needed */}
                                                 {/* <div className='flex justify-center ml-6 print:hidden self-center'>
                                                     <button
                                                         type="button"
                                                         onClick={() => addNewItem(columnId, 'text', 'Customer Value')} // Or Business Value
                                                         className="flex items-center h-10 w-10 justify-center p-3 rounded-md border border-dashed border-green-500/50 text-green-500 hover:bg-green-500/10 transition-colors"
                                                         title="Add Value"
                                                     >
                                                        <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4v16m8-8H4" /></svg>
                                                     </button>
                                                 </div> */}
                                             </div>
                                         )}

                                         {/* Technology Section */}
                                         {columnId !== 'conclusion' && columnId !== 'introduction' && column.items?.some(item => item.type === 'technology') && (
                                             <div className='w-full flex items-start pt-6'>
                                                 <img src="/util/app/b3-admin-path-tech.svg" className="h-7 opacity-80 mr-4 mt-1 print:hidden" alt="Tech Icon"/>
                                                 <div className="flex-grow grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
                                                     {column.items
                                                         .filter(item => item.type === 'technology')
                                                         .map(item => renderItem(item, columnId))}
                                                 </div>
                                                  {/* Add Technology Button Placeholder - Uncomment if needed */}
                                                 {/* <div className='flex justify-center ml-6 print:hidden self-center'>
                                                    <button
                                                         type="button"
                                                         onClick={() => addNewItem(columnId, 'technology', 'Technology')} // Adjust default content
                                                         className="flex items-center h-10 w-10 justify-center p-3 rounded-md border border-dashed border-amber-500/50 text-amber-500 hover:bg-amber-500/10 transition-colors"
                                                          title="Add Technology"
                                                     >
                                                         <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4v16m8-8H4" /></svg>
                                                     </button>
                                                 </div> */}
                                             </div>
                                         )}

                                         {/* Outcomes Section (Rendered only once in Conclusion) */}
                                         {columnId === 'conclusion' && column.items?.some(item => item.type === 'outcome') && (
                                             <div className="pt-6 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 ml-10">
                                                  {/* Removed explicit grid here, renderItem handles individual cards */}
                                                  {column.items
                                                     .filter(item => item.type === 'outcome')
                                                     .map(item => renderItem(item, columnId))}
                                             </div>
                                         )}

                                         {/* Render other intro/conclusion text items (e.g., Summary, Future Implications) */}
                                         {(columnId === 'introduction' || columnId === 'conclusion') && column.items?.filter(item => item.type === 'text' && item.label !== 'Customer Value' && item.label !== 'Business Value').map(item => (
                                                <div key={item.id} className="space-y-4 px-4"> {/* Add padding */}
                                                    {renderItem(item, columnId)}
                                                </div>
                                            ))}
                                    </div>
                                </div>
                            </Element>
                             {/* Add Scene Button Placeholder - Uncomment if needed */}
                            {/* {columnId.startsWith('chapter-') && (
                                <div className="flex justify-center pt-8 print:hidden">
                                    <button
                                        type="button"
                                        onClick={() => addNewScene(columnId)}
                                        className="flex items-center justify-center p-3 rounded-lg border border-dashed border-sky-500/50 text-sky-500 hover:bg-sky-500/10 transition-colors"
                                    >
                                        <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4v16m8-8H4" /></svg>
                                        <span className="ml-2">Add Scene</span>
                                    </button>
                                </div>
                            )} */}
                        </React.Fragment>
                    ))}
                </div>
            </div>


            {/* Third child - Comments sidebar */}
             <div className={`h-full bg-zinc-900 transition-all duration-300 relative print:hidden ${showCommentsSidebar ? 'w-2/12' : 'w-0 opacity-0'}`}>
                 {/* Toggle Button */}
                 <button
                    onClick={() => setShowCommentsSidebar(!showCommentsSidebar)}
                     className="absolute -left-8 top-2 bg-zinc-900 text-zinc-400 hover:text-zinc-200 p-2 rounded-l-lg shadow-lg transition-colors z-30" // Increased z-index
                    title={showCommentsSidebar ? "Hide Comments" : "Show Comments"}
                >
                    <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
                        {showCommentsSidebar
                            ? <path fillRule="evenodd" d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z" clipRule="evenodd" />
                            : <path fillRule="evenodd" d="M12.707 5.293a1 1 0 010 1.414L9.414 10l3.293 3.293a1 1 0 01-1.414 1.414l-4-4a1 1 0 010-1.414l4-4a1 1 0 011.414 0z" clipRule="evenodd" />}
                    </svg>
                </button>

                 {/* Comments Content */}
                {showCommentsSidebar && (
                     <div className="pl-4 py-4 flex flex-col h-full overflow-hidden"> {/* Added overflow hidden */}
                         <div className="flex items-center justify-between mb-4 pr-4"> {/* Added padding right */}
                             <h3 className="text-zinc-50 text-base font-medium">Comments</h3> {/* Adjusted font weight */}
                            <div className="flex items-center gap-2">
                                <span className="text-xs text-zinc-400 mr-1">Show:</span>
                                <button
                                    onClick={() => setShowAllComments(false)}
                                     className={`px-2 py-0.5 rounded text-xs ${!showAllComments ? 'bg-sky-600 text-white' : 'bg-zinc-700 text-zinc-300 hover:bg-zinc-600'}`}
                                >
                                    Current
                                </button>
                                 <button
                                     onClick={() => setShowAllComments(true)}
                                     className={`px-2 py-0.5 rounded text-xs ${showAllComments ? 'bg-sky-600 text-white' : 'bg-zinc-700 text-zinc-300 hover:bg-zinc-600'}`}
                                 >
                                    All
                                </button>
                            </div>
                        </div>

                         {/* Comments List */}
                         <div className="flex-1 overflow-y-auto mb-4 pr-2 custom-scrollbar"> {/* Added custom scrollbar class if needed */}
                            <div className="space-y-3">
                                {(showAllComments ? Object.values(mockComments).flat() : (mockComments[activeSection] || []))
                                    .sort((a, b) => new Date(b.timestamp) - new Date(a.timestamp))
                                    .map(comment => (
                                        <div key={comment.id} className="bg-zinc-800/60 rounded-lg p-3 mr-2"> {/* Added margin right */}
                                            <div className="flex items-center gap-2 mb-2">
                                                <img
                                                    src={comment.user.avatar || '/media/persona/default.png'} // Default avatar
                                                    alt={comment.user.name}
                                                    className="w-6 h-6 rounded-sm bg-zinc-600 flex-shrink-0" // Smaller avatar
                                                />
                                                <span className="text-zinc-200 text-xs font-medium truncate">{comment.user.name}</span> {/* Truncate name */}
                                                <span className="text-zinc-500 text-xs ml-auto flex-shrink-0">
                                                    {getTimeAgo(comment.timestamp)}
                                                </span>
                                            </div>
                                            <p className="text-zinc-300 text-sm leading-snug">{comment.content}</p> {/* Adjusted line height */}
                                        </div>
                                    ))}
                                 {!(showAllComments ? Object.values(mockComments).flat() : (mockComments[activeSection] || [])).length && (
                                     <p className="text-zinc-500 text-sm text-center py-4">No comments {showAllComments ? 'yet.' : 'for this section.'}</p>
                                 )}
                            </div>
                        </div>

                         {/* New Comment Input */}
                         <div className="pr-4 pb-2"> {/* Added padding right/bottom */}
                            <div className="relative">
                                <textarea
                                    value={newComment}
                                    onChange={(e) => setNewComment(e.target.value)}
                                     placeholder={`Comment on ${columns[activeSection]?.title || 'current section'}...`}
                                     className="w-full bg-zinc-800 border border-zinc-700 text-zinc-200 rounded-lg pl-3 pr-10 py-2 text-sm resize-none focus:border-sky-500 focus:ring-1 focus:ring-sky-500 focus:outline-none transition-colors custom-scrollbar"
                                    rows={2} // Reduced rows
                                    onKeyDown={(e) => {
                                        if (e.key === 'Enter' && !e.shiftKey) {
                                            e.preventDefault();
                                            handleAddComment();
                                        }
                                    }}
                                />
                                 <button
                                    onClick={handleAddComment}
                                    className={`absolute right-2 bottom-2 text-sky-500 hover:text-sky-400 disabled:text-zinc-500 disabled:cursor-not-allowed transition-colors`}
                                    disabled={!newComment.trim()}
                                    title="Add Comment (Enter)"
                                >
                                    <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
                                        <path d="M10.894 2.553a1 1 0 00-1.788 0l-7 14a1 1 0 001.169 1.409l5-1.429A1 1 0 009 15.571V11a1 1 0 112 0v4.571a1 1 0 00.725.962l5 1.428a1 1 0 001.17-1.408l-7-14z" />
                                    </svg>
                                </button>
                            </div>
                        </div>
                    </div>
                 )}
             </div>
        </div>
    );
};

export default PathProductArtOfPossible;